import { useSkeleton } from '@fire-framework/composables/useSkeleton'
import { VBtn } from 'vuetify/components'
import { makeVBtnProps } from 'vuetify/lib/components/VBtn/VBtn.mjs'
export default defineComponent({
  name: 'VBtnExtended',
  props: {
    ...makeVBtnProps(),
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { slots, attrs }) {
    const { showSkeleton } = useSkeleton(() => props.skeleton)
    return () => {
      if (showSkeleton.value) {
        const { class: externalClass, style: externalStyle, ...otherAttrs } = attrs
        const wrapperProps = {
          ...otherAttrs,
          class: [props.class, externalClass, 'skeleton', 'skeleton--element'].filter(Boolean).join(' '),
          style: [props.style, externalStyle, { display: 'inline-table', width: 'max-content', height: 'max-content' }],
        }
        return h('div', wrapperProps, [
          h(
            VBtn,
            {
              ...props,
              disabled: true,
              style: { visibility: 'hidden', pointerEvents: 'none' },
            },
            slots,
          ),
        ])
      } else {
        return h(VBtn, { ...props, ...attrs }, slots)
      }
    }
  },
})
